/**
 * 🔄 MODAL D'ENRICHISSEMENT (ANCIEN SYSTÈME)
 * 
 * Modal pour enrichir un nœud existant avec de nouvelles données
 * Conservé pour compatibilité avec l'ancien système de détection
 * 
 * @deprecated Préférer ConflictResolutionModal pour les nouvelles implémentations
 */

import React from 'react';
import './modals/ConflictResolutionModal.css'; // Réutiliser les styles

const EnrichmentModal = ({ enrichmentProposal, onClose, onConfirm, loading }) => {
  if (!enrichmentProposal) return null;

  const { existingNode, proposedEnrichments, newData } = enrichmentProposal;

  const handleConfirm = () => {
    onConfirm({
      existingNode,
      newData,
    });
  };

  return (
    <div className="conflict-modal-overlay" onClick={onClose}>
      <div className="conflict-modal" onClick={(e) => e.stopPropagation()}>
        <div className="conflict-header">
          <div className="conflict-icon">🔄</div>
          <div className="conflict-title-block">
            <h2>Enrichir le nœud existant</h2>
            <p className="similarity-badge">
              Nœud: <strong>{existingNode.name}</strong>
            </p>
          </div>
          <button 
            className="close-btn" 
            onClick={onClose}
            disabled={loading}
          >
            ✕
          </button>
        </div>

        <div className="conflict-explanation">
          <p>
            Un nœud avec le nom "{existingNode.name}" existe déjà. 
            {proposedEnrichments && proposedEnrichments.length > 0 
              ? ` ${proposedEnrichments.length} enrichissement(s) possible(s).`
              : ' Voulez-vous l\'enrichir avec les nouvelles données ?'
            }
          </p>
        </div>

        {proposedEnrichments && proposedEnrichments.length > 0 && (
          <div style={{ padding: '24px' }}>
            <h3 style={{ marginBottom: '16px' }}>Enrichissements proposés :</h3>
            <ul style={{ listStyle: 'none', padding: 0 }}>
              {proposedEnrichments.map((enrichment, index) => (
                <li key={index} style={{ 
                  padding: '12px', 
                  backgroundColor: '#f9fafb', 
                  marginBottom: '8px',
                  borderRadius: '8px',
                  border: '1px solid #e5e7eb'
                }}>
                  <strong>{enrichment.field}</strong>
                  <div style={{ fontSize: '0.9rem', color: '#6b7280', marginTop: '4px' }}>
                    <div>Actuel : {enrichment.current}</div>
                    <div>Proposé : {enrichment.proposed}</div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="conflict-actions">
          <button
            className="action-btn enrich-btn recommended"
            onClick={handleConfirm}
            disabled={loading}
          >
            <span className="btn-icon">🔄</span>
            <span className="btn-text">{loading ? 'Enrichissement...' : 'Enrichir le nœud'}</span>
          </button>

          <button
            className="action-btn cancel-btn"
            onClick={onClose}
            disabled={loading}
          >
            <span className="btn-icon">❌</span>
            <span className="btn-text">Annuler</span>
          </button>
        </div>

        {loading && (
          <div className="resolving-indicator">
            <div className="spinner"></div>
            <span>Enrichissement en cours...</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default EnrichmentModal;
